import countries from 'assets/countries.json';

export const getCountryNameByCode = (code: string): string => {
  const country = countries.find((c) => c.cca2 === code);
  if (!country) return code;
  return country.name;
};
